import React, { useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from '../../components/ui/sonner';
import AdminLogin from './AdminLogin';
import AdminDashboard from './AdminDashboard';
import AdminReview from './AdminReview';
import { getToken, clearToken } from './api';

const AdminApp = () => {
  const [signedIn, setSignedIn] = useState(!!getToken());

  const handleSignOut = () => {
    clearToken();
    setSignedIn(false);
  };

  if (!signedIn) {
    return (
      <>
        <AdminLogin onSuccess={() => setSignedIn(true)} />
        <Toaster theme="dark" />
      </>
    );
  }

  return (
    <>
      <Routes>
        <Route index element={<AdminDashboard onSignOut={handleSignOut} />} />
        <Route path="review/:articleId" element={<AdminReview />} />
        <Route path="*" element={<Navigate to="/admin" replace />} />
      </Routes>
      <Toaster theme="dark" />
    </>
  );
};

export default AdminApp;
